import { render } from "./longterm.vue?vue&type=template&id=4f870d61&scoped=true"
import script from "./longterm.vue?vue&type=script&lang=js"
export * from "./longterm.vue?vue&type=script&lang=js"

import "./longterm.vue?vue&type=style&index=0&id=4f870d61&lang=scss&scoped=true"
import "./longterm.vue?vue&type=style&index=1&id=4f870d61&lang=css"

import exportComponent from "C:\\Project\\DeepLink\\OrionRaceWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f870d61"]])

export default __exports__